/**
 * /frontend/src/features/analytics/components/customers/VisitFrequencyBuckets.js
 */

import React from 'react';
import ChartContainer from '../shared/ChartContainer';
import ComparisonBarChart from '../charts/ComparisonBarChart';

/**
 * Visit frequency buckets chart.
 * @param {{data:Array<{label:string,customerCount:number}>}} props
 * @returns {JSX.Element}
 */
const VisitFrequencyBuckets = ({ data }) => (
  <ChartContainer title="Visit Frequency" subtitle="Visits per month (bucketed)">
    <ComparisonBarChart data={data} xKey="label" yKey="customerCount" />
  </ChartContainer>
);

export default VisitFrequencyBuckets;

